/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import { toRoman } from 'solis/util/roman';

import AccountCass from 'solis/logic/account/cass';


export const getScoreCount = (settings, rounds) =>
{
  return rounds / settings.getBoardScoreRounds();
};


export const getCurrencyReward = (settings, rounds, risk) =>
{
  return Math.round(settings.getBoardReward() * getScoreCount(settings, rounds) * getCurrencyRiskMultiplier(settings, risk));
};


export const getCurrencyRiskMultiplier = (settings, risk) =>
{
  return Math.pow(2, (risk - settings.getMinBoardRisk()) / 0.2);
};


export default class BoardCass extends Logic
{
  constructor (board)
  {
    super(board);

    this.settings = board.getSettings();
  }


  initializeName (colony)
  {
    const sector = colony.getSector(colony.cass.id);

    sector.set({ boardCount: sector.cass.boardCount + 1 });

    this.object.set({ name: colony.cass.name + ' ' + toRoman(sector.cass.boardCount) });
  }


  hasEnoughDurationForAttach (now)
  {
    return this.cass.destroyDate - now >= this.settings.getMinBoardAttachDuration();
  }


  isAccountWithinTerritoryRange (account, galaxy)
  {
    const territory = new AccountCass(account, galaxy).getScore().cass.territory;

    return territory >= this.cass.minTerritory && territory <= this.cass.maxTerritory;
  }


  getDuration ()
  {
    return this.settings.getDuration(this.cass.rounds);
  }


  getScoreCount ()
  {
    return getScoreCount(this.settings, this.cass.rounds);
  }


  getRemainingScoreCount (now)
  {
    return (this.cass.destroyDate - now) / this.settings.getBoardScoreDuration();
  }


  getNextScoreDate (now)
  {
    return this.cass.destroyDate - (Math.ceil(this.getRemainingScoreCount(now)) - 1) * this.settings.getBoardScoreDuration();
  }


  getCurrencyReward ()
  {
    return getCurrencyReward(this.settings, this.cass.rounds, this.cass.risk);
  }


  getCurrencyRiskMultiplier ()
  {
    return getCurrencyRiskMultiplier(this.settings, this.cass.risk);
  }


};
